import React, { memo } from 'react';
import { SparklesIcon, Leaf, TrendingUpIcon } from 'lucide-react';
const ValueCards = () => {
  return <section className="py-20 bg-white" data-id="element-947">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-948">
        <div className="text-center mb-16" data-id="element-949">
          <h2 className="text-3xl font-bold text-navy-950 sm:text-4xl" data-id="element-950">
            Why leading showrooms choose SmartSoda
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-951">
            The premium beverage solution transforming customer experiences and
            driving sales
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-952">
          {/* Card 1 */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow flex flex-col items-center" data-id="element-953">
            <div className="mb-6 bg-blue-50 p-4 rounded-full" data-id="element-954">
              <SparklesIcon className="h-8 w-8 text-blue-600" data-id="element-955" />
            </div>
            <h3 className="text-xl font-semibold text-navy-950 mb-4 text-center" data-id="element-956">
              Luxury Customer Experience
            </h3>
            <p className="text-gray-600 text-center" data-id="element-957">
              Create a premium atmosphere with sophisticated beverage options
              that make customers feel valued and enhance their showroom
              experience.
            </p>
          </div>
          {/* Card 2 */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow flex flex-col items-center" data-id="element-958">
            <div className="mb-6 bg-green-50 p-4 rounded-full" data-id="element-959">
              <Leaf className="h-8 w-8 text-green-600" data-id="element-960" />
            </div>
            <h3 className="text-xl font-semibold text-navy-950 mb-4 text-center" data-id="element-961">
              Sustainability Showcase
            </h3>
            <p className="text-gray-600 text-center" data-id="element-962">
              Demonstrate your commitment to environmental values with a
              zero-waste beverage system that resonates with today's
              eco-conscious consumers.
            </p>
          </div>
          {/* Card 3 */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow flex flex-col items-center" data-id="element-963">
            <div className="mb-6 bg-amber-50 p-4 rounded-full" data-id="element-964">
              <TrendingUpIcon className="h-8 w-8 text-amber-600" data-id="element-965" />
            </div>
            <h3 className="text-xl font-semibold text-navy-950 mb-4 text-center" data-id="element-966">
              Sales Conversion Booster
            </h3>
            <p className="text-gray-600 text-center" data-id="element-967">
              Increase customer dwell time by up to 27% and create a comfortable
              environment where customers are more likely to make purchasing
              decisions.
            </p>
          </div>
        </div>
        <div className="mt-12 text-center" data-id="element-968">
          <a href="#book-demo" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-lg shadow-md text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all" data-id="element-969">
            Transform Your Showroom Experience
          </a>
        </div>
      </div>
    </section>;
};
export default ValueCards;